import { FC } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AudioPlayer } from '@aidkitorg/component-library';
import { usePost } from '../../../../API';
import { useLocalizedStrings } from '../../../../Localization';

interface AudioPlayerWithSignedUrlProps {
  audioPath: string;
  messageId: string;
  direction: 'inbound' | 'outbound';
}

export const AudioPlayerWithSignedUrl: FC<AudioPlayerWithSignedUrlProps> = ({
  audioPath,
  messageId,
  direction
}) => {
  const L = useLocalizedStrings();
  const getSignedURL = usePost('/v2/document/view');

  const { data: signedUrl, isLoading: loading, isError: error } = useQuery({
    queryKey: ['signedUrl', audioPath],
    queryFn: async () => {
      const result = await getSignedURL({ paths: [audioPath] });
      if (result && result.paths && result.paths[audioPath] && result.paths[audioPath].length > 0) {
        console.log('Signed URL fetched:', result.paths[audioPath]);
        // TODO(Riley): How much do we want to worry about multiple signed URLs here right now? We could send a sentry warning
        return result.paths[audioPath][0];
      } else {
        console.error('No signed URL returned for path:', audioPath);
        throw new Error('No signed URL returned');
      }
    },
    enabled: !!audioPath,
    staleTime: 5 * 60 * 1000, // Consider signed URLs fresh for 5 minutes
  });

  if (loading) {
    return (
      <div className="bg-white border rounded-xl p-2.5">
        <div className="text-sm text-gray-500">{L.applicant.comms.loading_audio}</div>
      </div>
    );
  }

  if (error || !signedUrl) {
    return (
      <div className="bg-white border rounded-xl p-2.5">
        <div className="text-sm text-gray-500 italic">{L.applicant.comms.unable_to_load_audio}</div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50/50 border rounded-xl p-1">
      <AudioPlayer
        item={{
          id: String(messageId),
          src: signedUrl,
        }}
        className="max-w-none"
      />
    </div>
  );
};
